import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEventbriteRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#f05537",
		d: "M16.2 28.4a12.7 12.7 0 1 0 0-25.3 12.7 12.7 0 0 0 0 25.3"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M15.2 11.3q3.1-.6 4.9 1.8l-8.4 2a5 5 0 0 1 3.5-3.8m5 7a5 5 0 0 1-2.9 1.9q-3 .5-4.9-1.9l8.5-1.9 1.3-.3 2.7-.6-.2-1.7a8.6 8.6 0 0 0-10.4-6.3c-4.6 1-7.5 5.6-6.4 10.2S13.6 25 18.2 24a9 9 0 0 0 6-4.8z"
	})]
});
export default SvgEventbriteRegularIcon;
